import React from 'react';
import Loadable from 'react-loadable';
import {LoadingIndicator} from '../LoadingIndicator/LoadingIndicator'

export const loadComponent = (loader, props) => {
    const LoadableComponent = Loadable({
        loader: () => loader(),
        loading: LoadingIndicator,
    })
    return (<LoadableComponent {...props}/>)
}


// WEBPACK FOOTER //
// ./src/components/LoadComponent/LoadComponent.js